import { render, staticRenderFns } from "./TipiOspite.vue?vue&type=template&id=e244fd44&"
import script from "./TipiOspite.vue?vue&type=script&lang=ts&"
export * from "./TipiOspite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports